/*
 * @Description: 全局注册
 * @Autor: WangYuan
 * @Date: 2021-06-04 16:00:49
 * @LastEditors: WangYuan
 * @LastEditTime: 2022-02-09 20:40:26
 */

import Vue from "vue";

// 注册所有全局组件
register(require.context("@/components/global", true, /.vue/));

// 注册所有配置组件
register(require.context("@/custom-schema-template", true, /.vue/));

// 注册所有物料
// register(require.context('../../../mall-cook-template/src/widgets', true, /.vue/))

// 获取所有物料初始数据与schema数据
registerComponentsSchema();

// /**
//  * 注册对应包下所有组件
//  * @param {*} path 包路径
//  */
function register(context) {
  context.keys().forEach((cnt) => {
    const component = context(cnt);
    let ctrl = component.default || component;
    let a = ctrl.name;
    let b = ctrl;

    // 注册组件
    Vue.component(a, b);
  });
}

// 获取所有自定义组件schema
function registerComponentsSchema() {
  let fields = {};
  let initializing = {};

  // 注册组件
  const componentPackages = [
    {
      name: "基础组件",
      path: require.context(
        "../../../mall-cook-template/src/components-base/components",
        true,
        /component.json$/,
      ),
    },
    {
      name: "学习组件",
      path: require.context(
        "../../../mall-cook-template/src/components-learn/components",
        true,
        /component.json$/,
      ),
    },
    {
      name: "题库组件",
      path: require.context(
        "../../../mall-cook-template/src/components-questionBank/components",
        true,
        /component.json$/,
      ),
    },
    {
      name: "支付宝组件",
      path: require.context(
        "../../../mall-cook-template/src/components-ali/components",
        true,
        /component.json$/,
      ),
    },
    {
      name: "财务组件",
      path: require.context(
        "../../../mall-cook-template/src/components-finance/components",
        true,
        /component.json$/,
      ),
    },
  ];

  componentPackages.forEach((pkg) => {
    pkg.path.keys().forEach((key) => {
      const [, name] = key.split("/");
      let config = { component: name, ...pkg.path(key) };

      fields[name] = config.fields;
      initializing[name] = initDefaulValue(config);
    });
  });

  Vue.prototype.$fields = fields;
  Vue.prototype.$initializing = initializing;
}

// 初始化组件初始数据
function initDefaulValue(config) {
  // console.log('initDefaulValue---config', config);
  let { component, name, icon, max, used, authStatus, fields, treeStyles } =
    config;
  let temp = { component, name, max, used, icon, authStatus, treeStyles };

  setDefaultValue(fields, temp);

  return temp;
}

// 递归设置各层级初始数据
function setDefaultValue(fields, initializing) {
  for (let key in fields) {
    let { type, value, child } = fields[key];
    if (type == "object") {
      initializing[key] = {};
      child && setDefaultValue(fields[key].child, initializing[key]);
    } else {
      initializing[key] = value;
    }
  }
  return initializing;
}
